import styled from 'styled-components';

import { theme } from '../../styled/layout/theme';
import { size } from '../../styled/layout/helpers';

export const OverflowSlider = styled.div`
  width: 100%;
  position: relative;
`;

export const Slider = styled.div`
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0;

  @supports (-moz-appearance: none) {
    overflow: hidden;
  }

  &.centered {
    text-align: center;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 0;
  }

  &.bleed {
    margin-left: -${size(2)};
    padding: 0 ${size(2)};
    width: calc(100% + ${size(4)});
    max-width: calc(100% + ${size(4)});

    & > *:last-child:after {
      content: '';
      min-width: 16px;
    }
  }
`;

const NavButton = styled.button`
  position: absolute;
  top: calc(50% - 12px);
  width: ${size(3)};
  height: ${size(3)};
  border-radius: 50%;
  background: ${theme.colors.button.base.default};
  color: ${theme.colors.button.base.text};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 125ms;

  &.fadeout {
    opacity: 0;
  }

  &.drilldown {
    top: ${size(4)};
  }

  svg {
    font-size: 16px;
  }

  ${theme.screens.Md} {
    top: calc(50% - 20px);
    width: ${size(5)};
    height: ${size(5)};

    svg {
      font-size: 24px;
    }

    &.drilldown {
      top: ${size(6)};
    }
  }
`;

export const NavLeft = styled(NavButton)`
  left: ${size(-1)};
`;

export const NavRight = styled(NavButton)`
  right: ${size(-1)};
`;

export const FadeLeft = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: ${size(4)};
  height: 100%;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
`;

export const FadeRight = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: ${size(4)};
  height: 100%;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
`;
